import React from "react";

const NavContext = React.createContext()

const NavContextProvider = ({ children }) => {
   const [isNavOpen, setIsNavOpen] = React.useState(false)

   const toggleNav = () => {
      setIsNavOpen(!isNavOpen)
   }

   return (
      <NavContext.Provider value={{ isNavOpen, toggleNav }}>
         {children}
      </NavContext.Provider>
   )
}

const useNav = () => {
   const context = React.useContext(NavContext)

   if (!context) {
      throw new Error('useNav should be used inside the NavContextProvider')
   }

   return context
}

export { NavContextProvider, useNav }